<template>
    <v-list-item>
        <v-list-item-content class="py-0">
            <v-list-item-title class="secondaryDarker--text mb-0">
                <h2 v-html="title" class="grey--text mb-0" :class="[small ? 'subtitle-2' : 'body-1']">{{title}}</h2>
            </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="action" class="my-0">
            <v-btn text small color="textLinks" class="caption text-capitalize subtitle-2"> See all</v-btn>
        </v-list-item-action>
    </v-list-item>
</template>
<style scoped>
.v-list-item {
    min-height: 10px;
}
</style>
<script>
export default {
    props: ['title', 'action', 'small']
}
</script>